import React, { useState, useEffect, useRef, useMemo, } from "react";
import ReactTooltip from "react-tooltip";
import {
  languageChange,
  currentSelectedLanguage,
} from "../../../../StateManagement/actions";
import { useSelector, useDispatch } from "react-redux";
import { Template } from "ckeditor5";
import CreateTemplate from "./CreateTemplate";
import FeatureTooltip from "./ToolTipDisplay";
import { setDocumentTemplates, setDocumentTemplateName } from "../../../../StateManagement/actions";
import APIRequest from "../../../../Services/commonAPIConsumer";
import EditTemplate from "./EditTemplate";
const ManageTemplate = ({
  isOpen,
  handleCancel,
  maxReadsText,
  maxViewsPerDocumentText,
  maxPrintsPerReaderText,
  maxPrintsPerDocumentText,
  Domains,
  ConstContinents,
  ConstMultipleIps
}) => {
  const selectedLanguage = useSelector(currentSelectedLanguage);
  const [isTemplateCreation, setIsTemplateCreation] = useState(false);
  const [IsManageTemplate, setIsManageTemplate] = useState(true);
  const [showFeaturesPopup, setShowFeaturesPopup] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [templateToDelete, setTemplateToDelete] = useState(null);
  const [isDeleting, setIsDeleting] = useState(false)
  const [isEditTemplate, setIsEditTemplate] = useState(false);
  const [template, setTemplate] = useState(null);
  const dispatch = useDispatch();
  const TemplatesData = useSelector((state) => state.documentTemplates.docTemplateOptions);
  const TemplateCreationClick = () => {
    setIsTemplateCreation(true);
    setIsManageTemplate(false);
    setTemplate(null);
  };

  const TemplateCreationClose = () => {
    setIsTemplateCreation(false);
  };
  const handleFeatureClick = (template) => {
    setSelectedTemplate(template);
    setShowFeaturesPopup(true);
  };
  const onDeleteHandler = (record) => {
    setTemplateToDelete(record);
    setShowDeletePopup(true);
    setIsTemplateCreation(false);
  };
  const handleFinish = () => {
    handleCancel();
    if (!TemplatesData || TemplatesData.length === 0) return;
    const latestTemplate = TemplatesData[TemplatesData.length - 1];
  };
  const onEditHandler = (record) => {
    setIsEditTemplate(true);
    setTemplate(record);
    setIsTemplateCreation(false);
    setIsManageTemplate(false);

  }

  const handleCancelEdit = () => {
    setIsEditTemplate(false);
    setIsTemplateCreation(false);
    setIsManageTemplate(true);
  }
  const handleCancelCreation = () => {
    setIsTemplateCreation(false);
    setIsManageTemplate(true);
  }
  const handleConfirmDelete = async () => {
    if (!templateToDelete) return;
    try {
      setIsDeleting(true);
      const formData = new FormData();
      formData.append("TemplateId", templateToDelete?.id || templateToDelete?._id);
      const response = await APIRequest.POST(
        formData,
        `${process.env.REACT_APP_API + "/docs/DocumentTemplate"}`
      );
      dispatch(setDocumentTemplates(response?.docTemplateOptions));
      setShowDeletePopup(false);
    } catch (err) {
      console.error("Delete failed:", err);
    } finally {
      setIsDeleting(false);
    }
  };
   const RegionValues = [
    { value: 0, label: "Europe" },
    { value: 2, label: "North America" },
    { value: 3, label: "South America" },
    { value: 4, label: "Asia" },
    { value: 5, label: "Oceania" },
    { value: 1, label: "Africa" },
  ];
   const bannedRegions = useMemo(() => {
    if (!ConstContinents || (Array.isArray(ConstContinents) && ConstContinents.length === 0)) {
      return [];
    }
    const excludedSet = new Set(
      Array.isArray(ConstContinents)
        ? ConstContinents.map(Number)
        : String(ConstContinents).split(",").map(s => Number(s.trim())).filter(n => !isNaN(n))
    );
    const allValues = RegionValues.map(r => r.value);
    const banned = allValues.filter(v => !excludedSet.has(v));
    return banned;
  }, [ConstContinents]);

  const sortedColumns = useMemo(() => [
    selectedLanguage.LstLanguageCodes.UI_AllowResponsesTo,
    selectedLanguage.LstLanguageCodes.UI_ProofOfSending,
    selectedLanguage.LstLanguageCodes.UI_CanPrint,
    selectedLanguage.LstLanguageCodes.UI_EDisclosure,
    selectedLanguage.LstLanguageCodes.UI_TimeStamp,
    selectedLanguage.LstLanguageCodes.UI_MaxviewsPerDocument,
    selectedLanguage.LstLanguageCodes.UI_AllowedIP,
    selectedLanguage.LstLanguageCodes.UI_BannedRegions,
    selectedLanguage.LstLanguageCodes.UI_SendVerificationcodeText,
    selectedLanguage.LstLanguageCodes.UI_SendVerificationcodeEmail,
    selectedLanguage.LstLanguageCodes.UI_IDLeakers,
    selectedLanguage.LstLanguageCodes.UI_DisplayDistributionlist,
    selectedLanguage.LstLanguageCodes.UI_Voting,
    selectedLanguage.LstLanguageCodes.UI_ShareVotes,
    selectedLanguage.LstLanguageCodes.UI_NotificationofReading,
    selectedLanguage.LstLanguageCodes.UI_MaxReadsperReader,
    selectedLanguage.LstLanguageCodes.UI_RestrictToDomains,
  ], [selectedLanguage]);
  const LEVEL1_ALLOWED = useMemo(() => [
    selectedLanguage.LstLanguageCodes.UI_AllowResponsesTo,
    selectedLanguage.LstLanguageCodes.UI_ProofOfSending,
    selectedLanguage.LstLanguageCodes.UI_TimeStamp,
    selectedLanguage.LstLanguageCodes.UI_CanPrint,
    selectedLanguage.LstLanguageCodes.UI_EDisclosure,
    selectedLanguage.LstLanguageCodes.UI_AllowedIP,
    selectedLanguage.LstLanguageCodes.UI_BannedRegions,
  ], [selectedLanguage]);
  console.log("isTemplateCreation", isTemplateCreation);
  const LEVEL2_ALLOWED = useMemo(() => [
    selectedLanguage.LstLanguageCodes.UI_SendVerificationcodeText,
    selectedLanguage.LstLanguageCodes.UI_SendVerificationcodeEmail,
    selectedLanguage.LstLanguageCodes.UI_IDLeakers,
    selectedLanguage.LstLanguageCodes.UI_AllowResponsesTo,
    selectedLanguage.LstLanguageCodes.UI_ProofOfSending,
    selectedLanguage.LstLanguageCodes.UI_CanPrint,
    selectedLanguage.LstLanguageCodes.UI_EDisclosure,
    selectedLanguage.LstLanguageCodes.UI_DisplayDistributionlist,
    selectedLanguage.LstLanguageCodes.UI_Voting,
    selectedLanguage.LstLanguageCodes.UI_ShareVotes,
    selectedLanguage.LstLanguageCodes.UI_NotificationofReading,
    selectedLanguage.LstLanguageCodes.UI_TimeStamp,
    selectedLanguage.LstLanguageCodes.UI_MaxviewsPerDocument,
    selectedLanguage.LstLanguageCodes.UI_MaxReadsperReader,
    selectedLanguage.LstLanguageCodes.UI_RestrictToDomains,
 selectedLanguage.LstLanguageCodes.UI_AllowedIP,
    selectedLanguage.LstLanguageCodes.UI_BannedRegions,

  ], [selectedLanguage]);
  if (!isOpen) {
    return null;
  }
  return (
    <>
      {IsManageTemplate &&
        <div className="child-popup" id="myModal">
          <div
            className="modal-dialog modal-dialog-centered modal-lg mobile-modal"
            style={{ maxWidth: "42rem" }}
          >
            <div className="modal-content">
              <div className="modal-header">
                <h5
                  className="d-flex align-items-center text-danger fw-bold mb-0"
                  id="staticBackdropLabel"
                >
                  {selectedLanguage.LstLanguageCodes.UI_ManageTemplates}
                </h5>
              </div>

              <div
                className="modal-body"
                style={{ maxHeight: "60vh", overflow: "auto" }}
              >
                <table
                  className="inertable page-restTh"
                  style={{ marginTop: "3px" }}
                >
                  <thead className="bg-lightblue">
                    <tr>
                      {/* <th className="borderRight" style={{ minWidth: "4rem" }}>
                    {selectedLanguage.LstLanguageCodes.UI_Sno}
                  </th> */}
                      <th className="borderRight">
                        {selectedLanguage.LstLanguageCodes.UI_TemplateName}
                      </th>
                      <th className="borderRight">
                        {selectedLanguage.LstLanguageCodes.UI_FeatureSelected}
                      </th>
                      <th className="borderRight">
                        {selectedLanguage.LstLanguageCodes.UI_Actions}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {TemplatesData?.length > 0 &&
                      TemplatesData?.map((record, index) => (
                        <tr
                          className="borderrow text-wrap-custom"
                          key={record.id}
                        >
                          {/* <td className="pcs w-5p">
                        {index + 1}
                      </td> */}
                          <td className="cur w-25">
                            {record.templateName || ""}
                          </td>
                          <td className="w-10p">
                            <a
                              href="#"
                              onClick={(e) => {
                                e.preventDefault();
                                handleFeatureClick(record);
                              }}
                            >
                              {selectedLanguage.LstLanguageCodes.UI_View}
                            </a>
                          </td>

                          <td className="per w-12p">
                            <div className="d-flex align-items-center justify-content-center">
                              <span
                                title={selectedLanguage.LstLanguageCodes.UI_Edit}
                                style={{
                                  fontSize: "19px",
                                  cursor: "pointer",
                                  width: "27px",
                                }}
                                className="material-icons"
                                onClick={() => onEditHandler(record)}
                              >
                                edit
                              </span>

                              <img
                                src={"assets/img/icons/bin.png"}
                                className="h-15p ms-2"
                                style={{ cursor: "pointer" }}
                                alt="Delete"
                                title={selectedLanguage.LstLanguageCodes.UI_Delete}
                                onClick={() => onDeleteHandler(record)}
                              />
                            </div>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>

              <div className="modal-footer border-0 pt-1 pb-3 justify-content-between">
                <div>
                  <button
                    type="button"
                    className="btn btn-outline-success px-2 mt-2 add-rule truncate"
                    data-bs-target="#exampleModalToggle2"
                    data-bs-toggle="modal"
                    data-bs-dismiss="modal"
                    title={selectedLanguage.LstLanguageCodes.UI_AddRestriction}
                    onClick={TemplateCreationClick}
                  >
                    <span
                      className="material-icons me-2 font-20"
                      style={{ verticalAlign: "bottom" }}
                    >
                      add_circle_outline
                    </span>
                    {selectedLanguage.LstLanguageCodes.UI_CreateTemplateText}
                  </button>
                </div>
                <div className="d-flex align-items-center">
                  {/* <button
                type="button"
                className="btn btn-danger px-2 me-2 ms-1 w-140p truncate"
                data-bs-dismiss="modal"
                onClick={handleCancel}
              >
                {selectedLanguage.LstLanguageCodes.UI_Cancel}
              </button> */}

                  <button
                    type="button"
                    className="btn btn-primary px-2 ms-1 w-140p truncate"
                    data-bs-dismiss="modal"
                    onClick={handleFinish}
                  >
                    {/* {selectedLanguage.LstLanguageCodes.UI_Finish} */}
                    {selectedLanguage.LstLanguageCodes.UI_Close}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      }
      {isTemplateCreation && (
        <CreateTemplate
          isOpen={isTemplateCreation}
          template={template}
          handleCancel={handleCancelCreation}
          sortedColumns={sortedColumns}
          LEVEL1_ALLOWED={LEVEL1_ALLOWED}
          LEVEL2_ALLOWED={LEVEL2_ALLOWED}
          maxReadsText={maxReadsText}
          maxViewsPerDocumentText={maxViewsPerDocumentText}
          maxPrintsPerReaderText={maxPrintsPerReaderText}
          maxPrintsPerDocumentText={maxPrintsPerDocumentText}
         Domains={Domains}
          ConstContinents={bannedRegions}
          ConstMultipleIps={ConstMultipleIps}
        />
      )}
      {isEditTemplate &&
        <EditTemplate
          isOpen={isEditTemplate}
          Template={template}
          handleCancel={handleCancelEdit}
          sortedColumns={sortedColumns}
          LEVEL1_ALLOWED={LEVEL1_ALLOWED}
          LEVEL2_ALLOWED={LEVEL2_ALLOWED}
              maxReadsText={maxReadsText}
          maxViewsPerDocumentText={maxViewsPerDocumentText}
          maxPrintsPerReaderText={maxPrintsPerReaderText}
          maxPrintsPerDocumentText={maxPrintsPerDocumentText}
           Domains={Domains}
          ConstContinents={bannedRegions}
          ConstMultipleIps={ConstMultipleIps}

        //   handleCancel={closeEditModal}
        //   handleTemplateCreation={saveTemplate}
        />
      }
      {showFeaturesPopup && (
        <FeaturesPopup
          template={selectedTemplate}
          onClose={() => setShowFeaturesPopup(false)}
          level1={selectedLanguage.LstLanguageCodes.UI_TrackViews}
          level2={selectedLanguage.LstLanguageCodes.UI_TrackReaders}
          level3={selectedLanguage.LstLanguageCodes.UI_LimitReaders}
          selectedLanguage={selectedLanguage}
        />
      )}
      {showDeletePopup && (
        <div className="child-popup" id="myModal">
          <div className="Settingmodal-dialog  modal-dialog-centered">
            <div className="modal-content">
              <div className="mleft15 justify-content-center mb-3 modalheaederleft" style={{ marginLeft: '9px', marginRight: '0px' }}>
                <h4 className="mb-2 mt-2 text-danger fw-bold" htmlFor="">
                  {selectedLanguage.LstLanguageCodes.UI_Update}
                </h4>
              </div>
              <hr className="modalhorizontal" />
              <div
                className="d-flex justify-content-center flex-column mb-3 text-center"
                style={{ marginTop: "20px" }}>
                <p
                  className="w-100 f-w550"
                  style={{ display: "content", fontSize: "18px" }}>
                  {selectedLanguage.LstLanguageCodes.UI_DeletingtheTemplate}
                </p>
              </div>
              <div className="d-flex justify-content-center mb-4 ">
                <button
                  type="button"
                  className="btn btn-danger px-4 me-1"
                  data-bs-dismiss="modal"
                  onClick={() => setShowDeletePopup(false)}>
                  {selectedLanguage.LstLanguageCodes.UI_Cancel}
                </button>
                <button
                  type="button"
                  className="btn btn-primary px-4 ms-3"
                  onClick={handleConfirmDelete}>
                  {selectedLanguage.LstLanguageCodes.UI_Confirm}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );

};
const FeaturesPopup = ({ template, onClose, level1, level2, level3, selectedLanguage }) => {
  if (!template) return null;
  const TOOLTIP_LABEL_MAP = {
    [selectedLanguage.LstLanguageCodes.UI_SendVerificationcodeEmail]: selectedLanguage.LstLanguageCodes.UI_SendVerificationcodeEmail,
    [selectedLanguage.LstLanguageCodes.UI_SendVerificationcodeText]: selectedLanguage.LstLanguageCodes.UI_SendVerificationcodeText,
    [selectedLanguage.LstLanguageCodes.UI_ProofOfSending]: selectedLanguage.LstLanguageCodes.UI_ProofOfSending,
    [selectedLanguage.LstLanguageCodes.UI_NotificationofReading]: selectedLanguage.LstLanguageCodes.UI_NotificationofReading,
    [selectedLanguage.LstLanguageCodes.UI_Voting]: selectedLanguage.LstLanguageCodes.UI_Voting,
    [selectedLanguage.LstLanguageCodes.UI_ShareVotes]: selectedLanguage.LstLanguageCodes.UI_ShareVotes,
    [selectedLanguage.LstLanguageCodes.UI_DisplayDistributionlist]: selectedLanguage.LstLanguageCodes.UI_DisplayDistributionlist,
    [selectedLanguage.LstLanguageCodes.UI_IDLeakers]: selectedLanguage.LstLanguageCodes.UI_IDLeakers,
    [selectedLanguage.LstLanguageCodes.UI_TimeStamp]: selectedLanguage.LstLanguageCodes.UI_TimeStamp,
    [selectedLanguage.LstLanguageCodes.UI_CanPrint]: selectedLanguage.LstLanguageCodes.UI_CanPrint,
    [selectedLanguage.LstLanguageCodes.UI_AllowResponsesTo]: selectedLanguage.LstLanguageCodes.UI_AllowResponsesTo,
    [selectedLanguage.LstLanguageCodes.UI_EDisclosure]: selectedLanguage.LstLanguageCodes.UI_EDisclosure,
    [selectedLanguage.LstLanguageCodes.UI_MaxReadsperReader]: selectedLanguage.LstLanguageCodes.UI_MaxReadsperReader,
    [selectedLanguage.LstLanguageCodes.UI_MaxviewsPerDocument]: selectedLanguage.LstLanguageCodes.UI_MaxviewsPerDocument,
    [selectedLanguage.LstLanguageCodes.UI_MaxPrintsPerReader]: selectedLanguage.LstLanguageCodes.UI_MaxPrintsPerReader,
    [selectedLanguage.LstLanguageCodes.UI_MaxPrintsPerDocument]: selectedLanguage.LstLanguageCodes.UI_MaxPrintsPerDocument,
    [selectedLanguage.LstLanguageCodes.UI_RestrictToDomains]: selectedLanguage.LstLanguageCodes.UI_RestrictToDomains,
    [selectedLanguage.LstLanguageCodes.UI_AllowedIP]: selectedLanguage.LstLanguageCodes.UI_AllowedIP,
    [selectedLanguage.LstLanguageCodes.UI_BannedRegions]: selectedLanguage.LstLanguageCodes.UI_BannedRegions
  };
  const FEATURE_LABELS = {
    sendVerifiCationCodeEmail: selectedLanguage.LstLanguageCodes.UI_SendVerificationcodeEmail,
    sendVerifiCationCodeText: selectedLanguage.LstLanguageCodes.UI_SendVerificationcodeText,
    proofOfSending: selectedLanguage.LstLanguageCodes.UI_ProofOfSending,
    notificationOfReading: selectedLanguage.LstLanguageCodes.UI_NotificationofReading,
    voting: selectedLanguage.LstLanguageCodes.UI_Voting,
    voteSharing: selectedLanguage.LstLanguageCodes.UI_ShareVotes,
    distributionList: selectedLanguage.LstLanguageCodes.UI_DisplayDistributionlist,
    idLeakers: selectedLanguage.LstLanguageCodes.UI_IDLeakers,
    timestamp: selectedLanguage.LstLanguageCodes.UI_TimeStamp,
    canPrint: selectedLanguage.LstLanguageCodes.UI_CanPrint,
    allowResponsesTo: selectedLanguage.LstLanguageCodes.UI_AllowResponsesTo,
    eDisclosure: selectedLanguage.LstLanguageCodes.UI_EDisclosure
  };


  const MAX_FEATURE_LABELS = {
    maxReadsPerReader: selectedLanguage.LstLanguageCodes.UI_MaxReadsperReader,
    maxViewsPerDocument: selectedLanguage.LstLanguageCodes.UI_MaxviewsPerDocument,
  };

  const RegionValues = [
    { value: 0, label: "Europe" },
    { value: 2, label: "North America" },
    { value: 3, label: "South America" },
    { value: 4, label: "Asia" },
    { value: 5, label: "Oceania" },
    { value: 1, label: "Africa" },
  ];

  const enabledBoolFeatures = Object.keys(FEATURE_LABELS)
    .filter((key) => template[key] === true)
    .map((key) => ({ label: FEATURE_LABELS[key], value: null }))
const enabledMaxFeatures = Object.keys(MAX_FEATURE_LABELS)
    .filter((key) => {
      if (key === "maxPrintsPerReader" || key === "maxPrintsPerDocument") {
        return template.canPrint === true && template[key] && template[key] > 0;
      }
      return template[key] && template[key] > 0;
    }).map((key) => ({ label: MAX_FEATURE_LABELS[key], value: template[key] }));
  const restrictionFeatures = [];
 const BannedRegions = (() => {
    const v = template.regions || template.bannedRegions;
    if (Array.isArray(v)) return v.map(Number).filter(n => !isNaN(n));
    if (typeof v === "string" && v.trim()) return v.split(",").map(s => Number(s.trim())).filter(n => !isNaN(n));
    return [];
  })();
  if (BannedRegions.length > 0) {
     BannedRegions
      .map(v => RegionValues.find(r => r.value === v)?.label)
      .filter(Boolean)
      .join(", ");
    restrictionFeatures.push({
      label: `${selectedLanguage.LstLanguageCodes.UI_BannedRegions}`
    });
  }

  const allowedIPValue =
    Array.isArray(template.ips)
      ? template.ips.join(", ")
      : template.allowedIP || "";

  const restrictDomainValue =
  template.domains ||
    template.restricttoDomains ||
    template.restrictToDomains ||
    "";

  if (allowedIPValue) {
    restrictionFeatures.push({
      label: `${selectedLanguage.LstLanguageCodes.UI_AllowedIP}`,
    });
  }

  if (restrictDomainValue) {
    restrictionFeatures.push({
      label: `${selectedLanguage.LstLanguageCodes.UI_RestrictToDomains}`,
    });
  }

  const enabledFeatures = [...enabledBoolFeatures, ...enabledMaxFeatures, ...restrictionFeatures];

  return (
    <div className="child-popup">
      <div className="modal-dialog modal-dialog-centered modal-sm" style={{ maxWidth: '370px' }}>
        <div className="modal-content">

          {/* Header */}
          <div className="modal-header">
            <h5 className="text-danger fw-bold" style={{ color: 'rgb(220 53 69) !important' }}>
              {selectedLanguage.LstLanguageCodes.UI_FeatureSelected}:
            </h5>
            <button
              type="button"
              className="btn btn-outline-danger Readerclose modalclose download mt-1"
              style={{
                position: "absolute",
                top: "10px",
                right: "10px",
                zIndex: 10,
              }}
              onClick={onClose}
            >
              <span className="material-icons font-20">highlight_off</span>
            </button>
          </div>

          {/* Body */}
          <div className="modal-body" style={{ maxHeight: '350px', overflowY: 'auto' }}>
            <h6 className="" style={{
              color:
                template.rDocsLevel === 2
                  ? "#f0ad00"
                  : template.rDocsLevel === 1
                    ? "#5a8eff"
                    : "#dc3545",
              margin: 0,
            }}>{template.rDocsLevel == 1 ? level1 : template.rDocsLevel == 2 ? level2 : level3}</h6>

            {enabledFeatures.length === 0 ? (
              <p className="text-muted">{selectedLanguage.LstLanguageCodes.UI_NoFeaturesEnabled || "No features enabled"}</p>
            ) : (
              <div className="feature-list">
                {enabledFeatures.map((item, index) => (
                  <div
                    key={index}
                    className="feature-row"
                    style={{
                      border: "1px solid #ddd",
                      borderRadius: "6px",
                      padding: "8px 10px",
                      marginBottom: "6px",
                      background: "#fff",
                      backgroundColor: "#fafafa",
                    }}
                  >
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between"
                      }}
                    >
                      <span>
                        {index + 1}. {item.label}{item.value !== null && item.value > 0 ? ` ` : ""}
                      </span>
                      <FeatureTooltip label={TOOLTIP_LABEL_MAP[item.label] || item.label}
                        selectedLanguage={selectedLanguage}
                      />
                    </span>
                  </div>
                ))}
              </div>
            )}
          </div>

        </div>
      </div>
    </div>
  );
};




export default ManageTemplate;
